export default __webpack_public_path__ + "static/media/smiling-kids-donate.a04192e4.jpg";